import '../CsvJsonInfoPages.scss';


function Editions() {

    const data = [
        { field: 1, description: 'CAP ID Number (Char)' },
        { field: 2, description: 'Options Last Date Change (Date)' },
        { field: 3, description: 'Standard Equipment Last Date Change (Date)' },
        { field: 4, description: 'Technical Data Last Date Change (Date)' },
        { field: 5, description: 'Option Relationship Last Date Change (Date)' },
        { field: 6, description: 'Colour Trims and Hoods Links Last Date Change (Date)' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Editions</h1>
            <p>This file contains dates when information was last changed for each CAP iD number <br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDEditions.txt .txt<br />
                LIGHTS_yyyy-mm-dd_NVDEditions.txt .txt<br />
                HEAVIES_yyyy-mm-dd_NVDEditions.txt .txt<br />
                BIKES_yyyy-mm-dd_NVDEditions.txt .txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default Editions;
